import { TabContext, TabList, TabPanel } from '@mui/lab';
import { Box, Tab, Typography } from '@mui/material';
import { Gear, MusicNotesSimple, RowsPlusBottom, Sidebar } from '@phosphor-icons/react';
import { useState } from 'react';
import { IChatbotFlowModel } from '../../../data/models/chatbot';
import { AIVoiceReadSettings } from './AIVoiceReadSettings';
import { DropdownOptions } from './DropdownOptions';
import { FlyoutSettings } from './FlyoutSettings';

export const Functionality = ({
  chatData,
  onSetFlow,
}: {
  chatData: IChatbotFlowModel;
  onSetFlow: (data: any) => void;
}) => {
  const [value, setValue] = useState('1');
  const handleChange = (newValue: string) => {
    setValue(newValue);
  };

  return (
    <Box
      display="flex"
      flexDirection="column"
      justifyContent="space-between"
      gap="16px"
      width="100%"
    >
      <Box display="flex" flexDirection="column" gap="16px">
        <Box display="flex" alignItems="center" gap="8px" width="100%" mb="8px">
          <Gear size={20} color="#101828" />
          <Typography
            sx={{
              fontSize: '20px',
              fontWeight: '500',
              color: '#101828',
            }}
          >
            Functionality Settings
          </Typography>
        </Box>

        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
            <TabList
              onChange={(_, newValue) => handleChange(newValue)}
              aria-label="lab API tabs example"
            >
              <Tab
                label={
                  <Box display="flex" gap="8px" alignItems="center">
                    <Sidebar size={20} />
                    Flyout Settings
                  </Box>
                }
                value="1"
              />
              <Tab
                label={
                  <Box display="flex" gap="8px" alignItems="center">
                    <MusicNotesSimple size={20} />
                    Ai Voice Read
                  </Box>
                }
                value="2"
              />
              <Tab
                label={
                  <Box display="flex" gap="8px" alignItems="center">
                    <RowsPlusBottom size={20} />
                    Dropdown options
                  </Box>
                }
                value="3"
              />
            </TabList>
          </Box>

          <TabPanel value="1" sx={{ padding: '0px' }}>
            <FlyoutSettings chatData={chatData} onSetFlow={onSetFlow} />
          </TabPanel>

          <TabPanel value="2" sx={{ padding: '0px' }}>
            <AIVoiceReadSettings chatData={chatData} onSetFlow={onSetFlow} />
          </TabPanel>

          <TabPanel value="3" sx={{ padding: '0px' }}>
            <DropdownOptions chatData={chatData} onSetFlow={onSetFlow} />
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
};
